<template>
  <div>
    <header class="header-main_v2">
      <nav class="mobile-menu">
      <div class="menu_v2_contains">
        <div class="logo">
          <a class="logo-header"><img :src="getTranslations.project_logo_img" alt=""></a>
        </div>
        <div class="items">
        <nav class="main-nav">
          <ul class="main-nav__lang">
            <li class="dropdown">
              <a><div class="icon-globe" >
                <img src="static/images/icon-globe.svg" alt="">
              </div></a>
              <ul>
                <li v-for="(value, key) in availableLocales" :key="key">
                  <a @click.prevent="changeLanguage(key)" style="cursor:pointer">{{ value }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      </div>
      </nav>
    </header>
    <main class="get-started height_hid">
      <div class="row">
        <h1 class="for_height">
          {{ getTranslations.visitor_index_get_started_msg_1 }}<br>
          <strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong>
        </h1>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="tablet"></div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="prize-img">
              <img src="static/images/Get-Started_prizes.png" alt="Duel prizes">
            </div>
          </div>
          <div class="row">
            <div class="button">
              <a style="cursor:pointer" @click.prevent="playTrial()" class="btn btn--large btn--main">{{ getTranslations.visitor_free_trial_play }}</a>
            </div>
          </div>
        </div>
      </div>
      <img class="get-started__free_trial free_off" src="static/images/free-trial-stripe.png" alt=""><!--ADD CLASS free_off TO HIDE FREE TRIAL RIBBON-->

    </main>
    <!-- MOBILE VIEW STARTS HERE -->
    <main class="get-started-mobile">
      <div class="row">
        <div class="col-md-12 tablet"><img src="static/images/safari_uc.png" alt=""></div>
        <div class="col-md-12 button">
          <a style="cursor:pointer" @click.prevent="playTrial()" class="btn btn--large btn--main gs_login_btn_desk">{{ getTranslations.visitor_free_trial_play }}</a>
        </div>
        <div class="col-md-12 title">
          <h1>
            {{ getTranslations.visitor_index_get_started_msg_1 }}<br>
            <strong>{{ getTranslations.visitor_index_get_started_msg_2 }}</strong>
          </h1>
        </div>
        <div class="col-md-12 prize-img">
          <img src="static/images/Get-Started_prizes.png" alt="Duel prizes"></div>
      </div>
    <img class="get-started__free_trial free_off" src="static/images/free-trial-stripe.png" alt=""><!--ADD CLASS free_off TO HIDE FREE TRIAL RIBBON-->
    </main>
    <footer class="footer-main">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a></li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a></li>
          </ul>
        </nav>
      </div>
  </footer>
  <div class="black-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { handleLanguageDropdown } from '../../../common/jQuery';

export default {
  name: 'getStartedFreePlay',
  mounted() {
    this.$nextTick(() => {
      handleLanguageDropdown();
    });
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from , next) {
    next((vm) => {
      vm.getParameterInfo(to);
    });
  },
  methods: {
    ...mapMutations('i18n', [
      'updateLocaleFromLocalStorage',
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    getParameterInfo(to) {
      console.log(to.query.lang);
     // console.log(to.query.refUrl);
    },
    playTrial() {
      console.log('playing...');
      this.$router.replace('trial/searchingOpponent');
    },
    changeLanguage(newValue) {
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile();
      this.changeCSSFile();
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GetStartedFreePlay.vue